import { useEffect, useRef, useState } from "react";

/* Scroll-triggered reveal wrapper — lightweight IntersectionObserver,
   CSS transitions only. Content is always visible under reduced motion
   (handled in index.css). */
export const Reveal = ({ children, delay = 0, className = "", as: Tag = "div", ...rest }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            setVisible(true);
            return;
        }
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -6% 0px" }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return (
        <Tag
            ref={ref}
            className={`reveal ${visible ? "is-visible" : ""} ${className}`}
            style={{ "--reveal-delay": `${delay}s` }}
            {...rest}
        >
            {children}
        </Tag>
    );
};
